export default function booleanConversion(stringValue) {
    if (stringValue === 'true') {
        return true
    }
    if (stringValue === 'false') {
        return false
    }
    return null

}